// Extracted from invoices/index.tsx to keep the grandfathered route under its
// existing line count when adopting the RouteShell wrapper.

import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

export type SortKey = "customer" | "period" | "status" | "sourceCharges" | "total" | "created";

export type SortDir = "asc" | "desc";

type SortHeaderProps = {
	label: string;
	sortKey: SortKey;
	currentSort: SortKey;
	currentDir: SortDir;
	onSort: (key: SortKey) => void;
	align?: "right";
};

export function SortHeader({
	label,
	sortKey,
	currentSort,
	currentDir,
	onSort,
	align,
}: SortHeaderProps) {
	const active = currentSort === sortKey;
	const Icon = active ? (currentDir === "asc" ? ArrowUp : ArrowDown) : ArrowUpDown;

	return (
		<th
			className={`px-4 py-2.5 text-xs font-medium uppercase tracking-wide text-[#6b7280] ${align === "right" ? "text-right" : ""}`}
		>
			<button
				type="button"
				onClick={() => onSort(sortKey)}
				className={`inline-flex items-center gap-1 transition-colors hover:text-[#1e1e20] ${align === "right" ? "flex-row-reverse" : ""} ${active ? "text-[#1e1e20]" : ""}`}
			>
				{label}
				<Icon className="h-3 w-3" strokeWidth={1.5} />
			</button>
		</th>
	);
}
